import * as Sentry from '@sentry/react'
import type { ZodType } from 'zod'

export function parseWithZod<T>(schema: ZodType<T>, data: unknown): T {
  if (import.meta.env.DEV) {
    return schema.parse(data)
  }

  const { data: parsedData, error, success } = schema.safeParse(data)
  if (success) {
    return parsedData
  }

  console.error('Zod parsing error:', error)
  Sentry.captureException(error)
  return data as T
}
